import Box from '~/core/Box'

interface SlideNumberPropsType {
    hide?: boolean
    idx: number
    isActiveSlide?: boolean
    isLocatedInModal?: boolean
}

const SlideNumber = (props: SlideNumberPropsType) => {
    const { hide = false, idx, isActiveSlide, isLocatedInModal } = props

    let marginTop = '16px'

    if (isActiveSlide) {
        marginTop = '25px'
    } else if (isLocatedInModal) {
        marginTop = '12px'
    }

    return (
        <Box
            display="block"
            style={{
                fontSize: '11px',
                marginTop,
                minWidth: '30px',
                padding: '0 8px',
                textAlign: 'center',
            }}
        >
            {!hide && idx + 1}
        </Box>
    )
}

export default SlideNumber
